module.exports = __webpack_public_path__ + "static/media/christmas-1500.ddd0d259.jpg";